const patchNotePath = patchNumber =>
  `/patch-note/${patchNumber.replace(/\./gi, '-')}`;

module.exports = exports = { patchNotePath };
